/** Width of the docked panel, and the padding the map leaves for it. */
export const PANEL_WIDTH_PX = 380;

/** Stacking order inside the map wrapper. */
export const PANEL_Z_INDEX = 1200;

/**
 * Popups have to clear the panel they belong to.
 *
 * antd bases every popup at z-index 1000, well under the panel, so a Select
 * dropdown, an autocomplete list or a Popconfirm portalled into the map
 * wrapper renders BEHIND the panel and looks like nothing happened. They
 * cannot portal to document.body instead: pseudo-fullscreen puts the wrapper
 * at z-index 99999, which a body-level popup would then sit behind.
 */
export const POPUP_Z_INDEX = 1400;
export const PANEL_GUTTER_PX = 24;

/** How many geocode candidates to ask for. Each one is billable. */
export const GEOCODE_CANDIDATE_LIMIT = 5;

/** Zoom to settle on when framing a single pin. */
export const PIN_ZOOM = 18;

/** Suggestions are cheap, but not free - wait for a pause in typing. */
export const SUGGEST_DEBOUNCE_MS = 300;

/** Below this, a query is a typo rather than a search. */
export const SUGGEST_MIN_CHARS = 3;

/**
 * How far from a collection location still counts as being at it, when the
 * location itself does not say.
 *
 * Matches the backend's DEFAULT_TRAPSITE_RADIUS_M. Applied here too so a row
 * predating the field behaves the same before any refetch.
 */
export const DEFAULT_TRAPSITE_RADIUS_M = 1000;

/**
 * How a collection location's boundary is drawn.
 *
 * Shared so the editor and the plain maps show the same thing - the circle is
 * what the radius field means, and it should not look like two different
 * concepts depending on which screen you are on.
 *
 * The drop shadow in `.trapsite-boundary` is what keeps the line readable:
 * these sit on satellite imagery, where a stroke of any single colour
 * eventually meets ground it disappears into.
 */
export const BOUNDARY_STYLE = {
  color: "#03a1ff",
  weight: 3,
  dashArray: "8 6",
  opacity: 1,
  fillColor: "#03a1ff",
  fillOpacity: 0.07,
  className: "trapsite-boundary",
};

/**
 * Ground claimed by more than one location.
 *
 * Only the shared patch is called out, not the whole of either circle: the
 * locations themselves are fine, it is the ground they both cover that is
 * ambiguous. A trap standing there could reasonably belong to either, so
 * neither the "too far away" warning nor the suggestion of a better home
 * means quite what it says.
 */
export const OVERLAP_REGION_STYLE = {
  color: "#ff3b30",
  weight: 2,
  opacity: 0.9,
  fillColor: "#ff3b30",
  fillOpacity: 0.35,
  className: "trapsite-overlap",
};
